







import {
  defineComponent,
  ComponentInternalInstance,
  getCurrentInstance,
  onUnmounted,
  onMounted,
  reactive,
} from '@vue/composition-api';
import SettingDialog from '@/renderer/components/dialog/setting/index.vue';
import rendererHandler from '@/renderer/views/desktop/headbar/composition/generalRendererHandler';
import ipc from '@/renderer/scripts/utils/ipc';
export default defineComponent({
  components: {
    SettingDialog,
  },
  setup(props, context) {
    const currComponent: ComponentInternalInstance = getCurrentInstance() as ComponentInternalInstance;
    const vm = currComponent.proxy;
    const settingInfo = reactive({
      defaultPage: '',
    }); // 设置中心默认展示页面

    const { showSetting } = rendererHandler();
    const methods = {
      showSettingDlg(info: { defaultPage: string }) {
        showSetting.value = true;
        if (info && info.defaultPage) {
          settingInfo.defaultPage = info.defaultPage;
        }
      },
    };
    onMounted(() => {
      ipc.on(ipc.RENDERER_EVENTS_MAP.SHOW_SETTING_DLG, methods.showSettingDlg);
    });
    onUnmounted(() => {
      ipc.off(ipc.RENDERER_EVENTS_MAP.SHOW_SETTING_DLG, methods.showSettingDlg);
    });
    return {
      ...methods,
      settingInfo,
      showSetting,
    };
  },
});
